/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_Ticket_DescInputs */

const en_vault_ticket_desc = /** @type {(inputs: Vault_Ticket_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This secure digital key verifies your purchase for on-site entry. Please present this QR code to the event staff or provider for immediate check-in.`)
};

const es_vault_ticket_desc = /** @type {(inputs: Vault_Ticket_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta llave digital segura verifica tu compra para la entrada en el lugar. Por favor, presenta este código QR al personal del evento.`)
};

const fr_vault_ticket_desc = /** @type {(inputs: Vault_Ticket_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette clé numérique sécurisée vérifie votre achat pour l'entrée sur place. Veuillez présenter ce code QR au personnel de l'événement ou au prestataire pour un enregistrement immédiat.`)
};

const de_vault_ticket_desc = /** @type {(inputs: Vault_Ticket_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser sichere digitale Schlüssel bestätigt deinen Kauf für den Einlass vor Ort. Bitte zeige diesen QR-Code dem Event-Personal.`)
};

const id_vault_ticket_desc = /** @type {(inputs: Vault_Ticket_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci digital aman ini memverifikasi pembelian Anda untuk akses di tempat. Silakan tunjukkan kode QR ini kepada staf acara atau penyedia layanan untuk check-in segera.`)
};

/** @type {(inputs: Vault_Ticket_DescInputs) => LocalizedString} */
const ja_vault_ticket_desc = en_vault_ticket_desc;

/** @type {(inputs: Vault_Ticket_DescInputs) => LocalizedString} */
const zh_vault_ticket_desc = en_vault_ticket_desc;

/** @type {(inputs: Vault_Ticket_DescInputs) => LocalizedString} */
const ar_vault_ticket_desc = en_vault_ticket_desc;

/** @type {(inputs: Vault_Ticket_DescInputs) => LocalizedString} */
const it_vault_ticket_desc = en_vault_ticket_desc;

/** @type {(inputs: Vault_Ticket_DescInputs) => LocalizedString} */
const ru_vault_ticket_desc = en_vault_ticket_desc;

/** @type {(inputs: Vault_Ticket_DescInputs) => LocalizedString} */
const pt_vault_ticket_desc = en_vault_ticket_desc;

/** @type {(inputs: Vault_Ticket_DescInputs) => LocalizedString} */
const ko_vault_ticket_desc = en_vault_ticket_desc;

/**
* | output |
* | --- |
* | "This secure digital key verifies your purchase for on-site entry. Please present this QR code to the event staff or provider for immediate check-in." |
*
* @param {Vault_Ticket_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_ticket_desc = /** @type {((inputs?: Vault_Ticket_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_Ticket_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_ticket_desc(inputs)
	if (locale === "es") return es_vault_ticket_desc(inputs)
	if (locale === "fr") return fr_vault_ticket_desc(inputs)
	if (locale === "de") return de_vault_ticket_desc(inputs)
	if (locale === "ja") return ja_vault_ticket_desc(inputs)
	if (locale === "zh") return zh_vault_ticket_desc(inputs)
	if (locale === "ar") return ar_vault_ticket_desc(inputs)
	if (locale === "id") return id_vault_ticket_desc(inputs)
	if (locale === "it") return it_vault_ticket_desc(inputs)
	if (locale === "ru") return ru_vault_ticket_desc(inputs)
	if (locale === "pt") return pt_vault_ticket_desc(inputs)
	return ko_vault_ticket_desc(inputs)
});